// extracted by mini-css-extract-plugin
export default {"badge":"dayOffArchive_badge__FiNWO","btnsGroup":"dayOffArchive_btnsGroup__9kWNS"};